import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-10874a1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "primary"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "30",
  width: "30",
  alt: "Ícone de sacola com frutas e legumes."
}, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhUserCircleGear = _resolveComponent("PhUserCircleGear")!
  const _component_PhArrowCircleLeft = _resolveComponent("PhArrowCircleLeft")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      (_ctx.headerType === 'Main')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("button", {
              class: _normalizeClass({
          active: _ctx.showActiveStatus
        }),
              id: "userButton",
              "aria-label": "Abrir menu de opções",
              title: "Abrir menu de opções",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitToggleOptionsMenu && _ctx.emitToggleOptionsMenu(...args)))
            }, [
              (_ctx.showProfilePic === true)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.userProfilePic,
                    height: "40",
                    width: "40",
                    alt: "Foto de perfil do usuário."
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.showProfilePic === false)
                ? (_openBlock(), _createBlock(_component_PhUserCircleGear, {
                    key: 1,
                    size: 40,
                    color: "#333333",
                    weight: "light"
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.headerType === 'Secondary')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              "aria-label": "Retroceder",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitGoBack && _ctx.emitGoBack(...args)))
            }, [
              _createVNode(_component_PhArrowCircleLeft, {
                size: 20,
                color: "'#333333'",
                weight: 'light'
              }),
              _createTextVNode(" Voltar ")
            ]),
            _createElementVNode("h1", null, _toDisplayString(_ctx.headerTitle), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "notification" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "notification", {}, undefined, true)
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "listCompanion", {}, undefined, true)
  ]))
}